import { defineMessages } from 'react-intl';

export default defineMessages({
  selectReason: {
    defaultMessage: 'Select Reason',
    description: 'returnReasonDropdown.selectReason',
    id: 'SAqm4L',
  },
});
